<template>
  <div>
    <v-toolbar>
      <v-tabs color="secondary"
              class="d-flex justify-center">
        <v-tab key="defaultTab" @click="loadActiveChecklistComponent">{{$vuetify.lang.t('$vuetify.checklist_components.main_checklist_component.tabs.active_checklist')}}</v-tab>
        <v-tab key="allChecklistsTab" @click="loadAllChecklistsComponent">{{$vuetify.lang.t('$vuetify.checklist_components.main_checklist_component.tabs.other_checklists')}}</v-tab>
      </v-tabs>
    </v-toolbar>
    <keep-alive>
      <component :is="currentActiveChecklistComponent"></component>
    </keep-alive>
  </div>
</template>

<script>
import defaultOrActiveCLComponent from "@/components/modules/checklist/DefaultOrActiveChecklisComponent";
import AllChecklistsComponent from "@/components/modules/checklist/AllChecklistsComponent";

const defaultChecklistComponent = 'dCL';
const allChecklistsComponent = 'aCLC';


export default {
  name: "Checklist",
  data: () => {
    return {
      currentActiveChecklistComponent: null
    }
  },
  components: {
    dCL: defaultOrActiveCLComponent,
    aCLC: AllChecklistsComponent,
  },
  methods: {
    loadActiveChecklistComponent() {
      this.currentActiveChecklistComponent = defaultChecklistComponent
    },
    loadAllChecklistsComponent() {
      this.currentActiveChecklistComponent = allChecklistsComponent
    },
  },
  async mounted() {
    this.currentActiveChecklistComponent = defaultChecklistComponent
  }
}
</script>

<style scoped>

</style>